<template>
  <div>
    <div id="riskEchartTwo"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "riskLeveEcharts",
  data() {
    return {
      myChart: {}
    };
  },
  props: {
    echartsData: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {
    let _this = this;
    // window.onresize = function() {
    //     _this.myChart.resize()
    // }
  },
  methods: {
    loadEchart() {
    //   let colors = ["#FACC14", "#EF2B4C"];
      let colors =this.$store.state.select.riskLevel.map((item)=>{
                return item.backgroundColor
            })
      this.myChart = Echarts.init(document.getElementById("riskEchartTwo"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "horizontal",
          bottom: 20,
          left: "center",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: colors
          },
          data: []
        },
        grid: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: [30, "50%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                // 设置扇形的阴影
                // shadowBlur: 30,
                // shadowColor: 'rgba(255,227,42,0.3)',
                // shadowOffsetX: -5,
                // shadowOffsetY: 5
              }
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 100,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ],
        color: colors
      };
      option.series[0].data = this.echartsData.map((item) => {
        return {
          name: item.type || "",
          value: item.totalNum || 0
        };
      });
      option.legend.data = this.echartsData.map((item) => {
        return item.type || "";
      });
      // console.log(option)
      this.myChart.setOption(option);
    }
  },
  watch: {
    echartsData: function(nval) {
      this.loadEchart();
    }
  }
};
</script>

<style scoped>
#riskEchartTwo {
  width: 100%;
  height: 260px;
}
</style>
